angular.module('common.directives.scrollIntoViewIf', [])

    .directive("scrollIntoViewIf", function ($animate, $timeout) {
        return ({
            restrict: 'A',
            scope: {
                scrollIntoViewIf: '='
            },
            link: function (scope, element, attrs) {
                var el = $(element);

                scope.$watch('scrollIntoViewIf', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal === true) {
                        //Bring into view if it's not visible already
                        if (!isElementInViewport(el[0])) {
                            bringIntoViewWithTimeout();
                        }
                    }
                });

                bringIntoViewWithTimeout();

                function bringIntoViewWithTimeout() {
                    $timeout(function () {
                        var result = angular.isDefined(scope.scrollIntoViewIf) && scope.scrollIntoViewIf === true;
                        if (angular.isDefined(result) && result === true) {
                            scope.$applyAsync(function () {
                                bringIntoView(el[0]);
                            });
                        }
                    }, 100);
                }

                function isElementInViewport() {
                    if (!el) return false;

                    var rect = el[0].getBoundingClientRect();
                    var elParent = el[0].parentElement;

                    return rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <= (elParent.innerHeight || elParent.clientHeight) &&
                        rect.right <= (elParent.innerWidth || elParent.clientWidth);
                }
            }
        });

        function bringIntoView(element) {
            element.scrollIntoView({ block: 'nearest' });
        }
    }
    );
